import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { isAuthenticated } from 'utils';

export const RedirectContainer = ({ children }) => {
  const history = useHistory();
  const isLogged = isAuthenticated();

  useEffect(() => {
    if (!isLogged && history.location.pathname === '/') {
      history.push('/consultaProcesso');
    }
  }, []);

  useEffect(() => {
    if (isLogged && window.location.search.includes('login')) {
      window.history.replaceState(null, null, window.location.pathname);
      history.push('/');
    }
  }, []);

  return <>{children}</>;
};
